import { getVideos } from "./videosAPI";

const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

const initialState = {
  videos: [],
  noOfVideos: 0,
  isLoading: false,
  isError: false,
  error: "",
};

// async thunk
export const fetchVideos = createAsyncThunk(
  "videos/fetchVideos",
  async ({ tags, search, author, start, limit }) => {
    const videos = await getVideos(tags, search, author, start, limit);

    return {
      videos: videos.data,
      totalRecords: videos.headers["x-total-count"],
    };
  }
);

const videoSlice = createSlice({
  name: "videos",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(fetchVideos.pending, (state) => {
        state.isError = false;
        state.isLoading = true;
      })
      .addCase(fetchVideos.fulfilled, (state, action) => {
        state.isLoading = false;
        state.videos = action.payload.videos;
        state.noOfVideos = action.payload.totalRecords;
      })
      .addCase(fetchVideos.rejected, (state, action) => {
        state.isLoading = false;
        state.noOfVideos = 0;
        state.videos = [];
        state.isError = true;
        state.error = action.error?.message;
      });
  },
});

export default videoSlice.reducer;
